export default "/images/vendor/flag-icons/flags/1x1/xx.svg?aa8f667027fd90e56320d7f3db57e8e0";